export var GetBrandUsersFilter;
(function (GetBrandUsersFilter) {
    GetBrandUsersFilter["All"] = "all";
    GetBrandUsersFilter["Admins"] = "admins";
    GetBrandUsersFilter["Users"] = "users";
})(GetBrandUsersFilter || (GetBrandUsersFilter = {}));
